/**
 * Utility to extract basename of an application mounted in router under given path segment
 * @example
 *   // given window.location.pathname is '/pm/c-xxx/my-app/reset-of-path/123'
 *   // returns '/pm/c-xxx/my-app'
 *   extractBasename('my-app')
 */
export const extractBasename = (pathSegment: string) => {
  const pathname = window.location.pathname;
  const trimmedPathname = pathname.slice(0, pathname.lastIndexOf(pathSegment));

  return trimmedPathname + pathSegment;
};
